import { render, staticRenderFns } from "./releaseList.vue?vue&type=template&id=446ef6c8&scoped=true"
import script from "./releaseList.vue?vue&type=script&lang=js"
export * from "./releaseList.vue?vue&type=script&lang=js"
import style0 from "./releaseList.vue?vue&type=style&index=0&id=446ef6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ef6c8",
  null
  
)

export default component.exports